import type { CoachBoardFocus } from './coach.types'

export function isSameCoachBoardFocus(
  first: CoachBoardFocus | undefined,
  second: CoachBoardFocus,
): boolean {
  return (
    first?.cellNumber === second.cellNumber &&
    first.tile === second.tile &&
    first.rotation === second.rotation
  )
}
